import SpendCountryReplacementRuleRepository from '@/repository/generatedRepository/spendCountryReplacementRuleRepository'
import TableOptions from '@/models/TableOptions'

const state = {
  list: [],
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  list: state => state.list,
  tableOptions: state => state.tableOptions,
}

const actions = {
  async loadList(context, { partner, active, pagination }) {
    const { data } = await SpendCountryReplacementRuleRepository.list({
      partner,
      ...(active !== undefined ? { active } : {}),
      pagination,
    })
    context.commit('setList', { data, pagination })
    return data
  },
  createItem(context, payload) {
    return SpendCountryReplacementRuleRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return SpendCountryReplacementRuleRepository.put(id, data)
  },
  deactivateItem(context, id) {
    return SpendCountryReplacementRuleRepository.deactivate(id)
  },
}

const mutations = {
  setList(state, { data, pagination }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, { pagination })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
